import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, signal, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { isDefined } from '@libs/utils';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from "primeng/chip";
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';

@Component({
  selector: 'app-about-me-question',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ButtonModule,
    ChipModule,
    SelectModule,
    SelectButtonModule
  ],
  templateUrl: './about-me-question.component.html',
  styleUrl: './about-me-question.component.scss'
})
export class AboutMeQuestionComponent {
  @Input() question: any = null;
  @Input() answer: any = null;
  @Input() currentStep: number = 0
  @Input() totalSteps: number = 0;
  @Input() showExitButton: boolean = true;
  @Output() onNext = new EventEmitter<any>();
  @Output() onPrev = new EventEmitter<void>();
  @Output() onSaveAndExit = new EventEmitter<void>();

  currentAnswer = signal<any | null>(null)
  isEditing = signal<boolean>(false);
  showYearsSelect = signal<boolean>(false);
  allYears = signal<any[]>([]);

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question']) {
      this.initAnswer();
    }
  }

  get chipIsActive() {
    return (option: any) => {
      return this.currentAnswer().options.findIndex((o: any) => o.text === option.text) > -1;
    };
  }

  initAnswer() {
    const definedAnswer = this.answer;
    this.allYears.set([]);
    if (!isDefined(definedAnswer) && this.question) {
      this.currentAnswer.set({
        question: this.question.id,
        text: '',
        options: []
      });
      this.isEditing.set(false);
    } else {
      const definedAnswersWithYears = definedAnswer.options.filter((o: any) => isDefined(o.years));
      if (definedAnswersWithYears.length > 0) {
        this.showYearsSelect.set(true);
        for (const answerWithYears of definedAnswersWithYears) {
          const questionYears = this.question.options.find((o: any) => o.text === answerWithYears.text)?.years || [];
          this.allYears.set([...this.allYears(), questionYears]);
        }
      }
      definedAnswer.question = this.question.id;
      this.currentAnswer.set(definedAnswer);
      this.isEditing.set(true);
    }
  }

  saveAndExit() {
    console.log('save and exit')
    this.onSaveAndExit.emit();
  }

  onNextStep() {
    const editedAnswer = this.currentAnswer();
    const event = {
      answer: editedAnswer,
      isEditing: this.isEditing()
    }
    this.onNext.emit(event);
  }

  onPreviousStep() {
    this.onPrev.emit();
  }

  editAnswerText(text: string) {
    const editedAnswer = this.currentAnswer();
    editedAnswer.text = text;
    this.currentAnswer.set(editedAnswer);
  }

  onOptionSelect(option: any) {
    const editedAnswer = this.currentAnswer();
    const elementToPush: any = { text: option.text }
    if (option.years.length > 0) {
      const currentAllYears = this.allYears();
      currentAllYears.push(option.years);
      this.allYears.set(currentAllYears);
      elementToPush.years = option.years[0]
      this.showYearsSelect.set(true);
    }
    editedAnswer.options.push(elementToPush)
    this.currentAnswer.set(editedAnswer);
  }

  onOptionRemove(event: any, option: any) {
    event.stopPropagation();
    event.preventDefault();
    const editedAnswer = this.currentAnswer();
    const toRemoveIndex = editedAnswer.options.findIndex((o: any) => o.text === option);
    editedAnswer.options.splice(toRemoveIndex, 1);

    const currentAllYears = this.allYears();
    currentAllYears.splice(toRemoveIndex, 1);

    this.allYears.set(currentAllYears);
    this.currentAnswer.set(editedAnswer);
  }

  onYesOrNoChange(event: any) {
    const editedAnswer = this.currentAnswer();
    editedAnswer.yesOrNot = event;
    this.currentAnswer.set(editedAnswer);
  }
}
